import { round } from 'lodash';
import { toDecimal4, toDecimal6 } from 'src/utils/toDecimal';
function generateTotals(columns = [], data = [], otherSettings = {}) {
  const { overrideTotals = {}, rounding = 2 } = otherSettings;
  const totals = {};

  for (const col of columns) {
    totals[col] = 0;
  }

  for (const row of data) {
    for (const col of columns) {
      if (col in overrideTotals) {
        totals[col] = overrideTotals[col];
        continue;
      }
      // Sum per-row rounded values
      if (rounding == 2) {
        totals[col] += round(row?.[col] || 0, 2);
      } else if (rounding == 4) {
        totals[col] += toDecimal4(row?.[col] || 0);
      } else if (rounding == 6) {
        totals[col] += toDecimal6(row?.[col] || 0);
      }
    }
  }

  // Optionally, round the final total as well
  for (const col of columns) {
    if (rounding == 2) {
      totals[col] = round(totals[col], 2);
    } else if (rounding == 4) {
      totals[col] = toDecimal4(totals[col] || 0);
    } else if (rounding == 6) {
      totals[col] = toDecimal6(totals[col] || 0);
    }
  }

  return totals;
}

export default generateTotals;
